export class Register{
    emailId: string;
    password:string;
    userName:string;
}
